import queryString from 'query-string';
import {
  QQ_SUPPORTED_PRODUCT_MODELS,
  COURSE_TYPE_SECTION_MANAGER,
} from './constants';
import { getConfigObject } from './config';

export const parseUrlQuery = (search = window.location.search) => {
  return queryString.parse(search);
};

export const isQQInsightsSupported = (productModelId) =>
  QQ_SUPPORTED_PRODUCT_MODELS.includes(productModelId);

export const toQueryString = (paramsObject) => {
  const params = Object.keys(paramsObject)
    .filter((key) => paramsObject[key] !== undefined)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
    )
    .join('&');
  if (params.length) {
    return `?${params}`;
  }

  return params;
};

export const getPathfinderUrl = (courseId) => {
  const CONFIG = window.config || {};
  const {
    TOOL_PROVIDERS: { pathfinder, 'pathfinder-2': pathfinder2 },
    LMS_ID,
  } = CONFIG;
  const { launch_prefix_url: launchPrefixUrl, launch_path_url: launchPathUrl } =
    pathfinder2 || pathfinder;
  const domain = CONFIG.S2S_DOMAIN;
  return `${launchPrefixUrl}${domain}${launchPathUrl}/${LMS_ID}/${courseId}/courseStats`;
};

export const roundtoTwoDecimals = (number) => Math.round(number * 100);

export function removeParamsFromId(param) {
  return param ? param.split(/[?#]/)[0] : param;
}

export const getTestName = (str) => `${str}`.replace(/\W/g, '_').toLowerCase();

export const getCwUrl = () => {
  const CONFIG = getConfigObject();

  let cwUrl = CONFIG.CW_SERVICES_URL_PREFIX + CONFIG.S2S_DOMAIN;
  if (CONFIG.CW_SERVICES_URL_PREFIX === 'https://courseware-service-local.') {
    cwUrl += `:${CONFIG.SERVICES_PORT}`;
    return cwUrl;
  }

  return CONFIG.COURSEWARE_LMS_URL;
};

export const getGBUrl = () => {
  const CONFIG = getConfigObject();
  const gbApiUrl = CONFIG.GRADEBOOK_SERVICE_URL;

  if (gbApiUrl) return gbApiUrl;

  let gbUrl = CONFIG.GRADEBOOK_API_URL_PREFIX + CONFIG.S2S_DOMAIN;
  if (CONFIG.GRADEBOOK_API_URL_PREFIX === 'http://gradebook-api-local.') {
    gbUrl += `:${CONFIG.GRADEBOOK_PORT}`;
  }
  return gbUrl;
};

export const isSectionCourseType = (courseType) => {
  const types = [COURSE_TYPE_SECTION_MANAGER];
  return types.includes(courseType);
};

export const getDashUrl = () => {
  const CONFIG = window.config || {};
  const dashApiUrl = CONFIG.DASHBOARD_API_URL;
  if (dashApiUrl) return dashApiUrl;

  let dashUrl = CONFIG.DASHBOARDS_SERVICE_PREFIX + CONFIG.S2S_DOMAIN;
  if (CONFIG.DASHBOARDS_SERVICE_PREFIX === 'http://dashboard-api-local.') {
    dashUrl += `:${CONFIG.DASHBOARDS_PORT}`;
  }
  return dashUrl;
};
